import { Placement, ToastLevel, ToastType } from '@philips-emr/tws-constants';
import { ToastService } from '@philips-emr/tws-core/lib/services';
import { ToastProps } from '@philips-emr/tws-core/lib/services/toast-service';

const extraToastOption: Omit<ToastProps, 'message' | 'title' | 'timeout' | 'id'> = {
  dismissible: true,
  placement: Placement.TOP,
  type: ToastType.BANNER,
  showIcon: true,
  highlight: false,
  offset: 70,
};

const extraToastBubbleOption: Omit<ToastProps, 'message' | 'title' | 'timeout' | 'id'> = {
  dismissible: true,
  placement: Placement.TOP,
  type: ToastType.BUBBLE,
  showIcon: true,
  highlight: false,
  offset: 70,
};

class ToastServiceStipulator {

  private static time = 5000;
  private static msg = 'stipulator.warning';

  public static error(message: string, title = this.msg, timeout: number = this.time, options?: Omit<ToastProps, 'message' | 'title' | 'timeout' | 'id'>): void {
    this.showToast(ToastLevel.ERROR, message, title, timeout, options);
  }

  public static information(message: string, title = this.msg, timeout: number = this.time, options?: Omit<ToastProps, 'message' | 'title' | 'timeout' | 'id'>): void {
    this.showToast(ToastLevel.INFORMATION, message, title, timeout, options);
  }

  public static success(message: string, title = this.msg, timeout: number = this.time, options?: Omit<ToastProps, 'message' | 'title' | 'timeout' | 'id'>): void {
    this.showToast(ToastLevel.SUCCESS, message, title, timeout, options);
  }

  public static warning(message: string, title = this.msg, timeout: number = this.time, options?: Omit<ToastProps, 'message' | 'title' | 'timeout' | 'id'>): void {
    this.showToast(ToastLevel.WARNING, message, title, timeout, options);
  }

  public static successBubble(message: string, title = this.msg, timeout: number = this.time): void {
    this.showToast(ToastLevel.SUCCESS, message, title, timeout, extraToastBubbleOption);
  }

  private static showToast(level: ToastLevel, message: string, title: string, timeout: number, options?: Omit<ToastProps, 'message' | 'title' | 'timeout' | 'id'>): void {
    const toastOption = { ...extraToastOption, ...options };

    ToastService.open({
      id: 'toast.service-stipulator',
      title,
      message,
      timeout,
      level,
      ...toastOption,
    });
  }

  public static close(): void {
    ToastService.close('toast.service-stipulator');
  }
}

export {
  ToastServiceStipulator,
};
